<template>
  <v-card
    :outlined="!selected"
    :color="selected ? 'primary' : ''"
    :dark="selected"
    :class="['init-config-course-card', { 'is-selected': selected }]"
    @click="$emit('select', course)"
  >
    <v-card-title class="text-base">
      {{ course.name }}
    </v-card-title>
    <v-card-text :class="selected ? 'white--text' : ''">
      <div>{{ durationMin }} 分</div>
      <div>{{ formattedPrice }} 円</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'InitConfigCourseCard',
  props: {
    course: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },
  emits: ['select'],
  setup(props) {
    // Course モデルの実フィールドは effective_duration_seconds（秒）
    // フォールバックとして servingTimeMin / durationMin もサポート
    const durationMin = computed(() => {
      const c = props.course || {}
      if (c.effectiveDurationSeconds != null) return Math.round(c.effectiveDurationSeconds / 60)
      if (c.servingTimeMin != null) return c.servingTimeMin
      if (c.durationMin != null) return c.durationMin

      return 0
    })

    const formattedPrice = computed(() => {
      const n = Number(props.course?.sellingPrice || 0)

      return n.toLocaleString('ja-JP')
    })

    return { durationMin, formattedPrice }
  },
}
</script>

<style scoped>
.init-config-course-card {
  cursor: pointer;
  min-height: 140px;
}
</style>
